export const quoteStatus = {
  noFinanceProduct: { id: -1, code: "NOFINPRD" },
  incompleteCustomerData: { id: -2, code: "INCCSTD" },
  pendingCustomerInfo: { id: -3, code: "PNDCSTNF" },
  pendingDecision: { id: -4, code: "PNDDCSN" },
  declined: { id: -5, code: "DECL" },
  pendingDocumentsUpload: { id: -6, code: "PNDDOCUP" },
  pendingDocumentsFromCustomer: { id: -7, code: "PNDDOCCUS" },
  completed: { id: -8, code: "COMPL" },
  funded: { id: -9, code: "FUND" },
  cancelled: { id: -10, code: "CANC" },
  documentsUploaded: { id: -11, code: "PNDAPR" },
  approved: { id: -12, code: "APR" },
  approvedWithConditions: { id: -13, code: "APRC" },
};
